export default __webpack_public_path__ + "static/media/avatar_dragon3.5523fe96.mp3";